import TaskListItemRoot, { Props } from './TaskListItem'

export default function TaskListItem(props: Props) {
  return <TaskListItemRoot {...props} />
}
